require("./m_ynet_newsFlashSpecialMobileComponent.less")
import * as axios from "axios";
import { ArticleExtraData } from "articlePage/stateInterfaces";
import { addAxiosDateTransformerSettings } from "../../../../../../utils/network/axiosDateTransformer";
import { NewsFlashSpecialMobileSlotList } from "./newsFlashSpecialMobileSlotList";

interface NewsFlashSpecialMobileComponentProps {
    isLTR: boolean
    domain: string
    componentaId?: string
    languageCode: string
    numberOfVisibleDays: number
    tickerCategoryId: string
    tickerBottomLink: string
    roofOngoingEvent: boolean
    tickerBottomTitle: string
    highlightingDuration: number
}

interface NewsFlashSpecialMobileComponentState {
    shouldDisplayTicker: boolean
    pageNumber: number
    tickerArticles: ArticleExtraData[]
    isFirstInterval: boolean
    shouldDisplayLoader: boolean
}

export class NewsFlashSpecialMobileComponent extends React.Component<NewsFlashSpecialMobileComponentProps, NewsFlashSpecialMobileComponentState> {

    public static siteScriptName = "NewsFlashSpecialMobileComponent"

    constructor(props) {
        super(props)
        this.state = {
            shouldDisplayTicker: true,
            pageNumber: 0,
            tickerArticles: [],
            isFirstInterval: true,
            shouldDisplayLoader: false,
        }
    }

    componentDidMount() {
        this.getTickerArticles()
        setInterval(() => {
            this.setState({ isFirstInterval: false })
            this.getTickerArticles()
        }, 60000);
    }

    private getTickerArticles() {
        const { componentaId, highlightingDuration } = this.props;
        const { isFirstInterval } = this.state;
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        const highlightDur = highlightingDuration ? highlightingDuration : 3;

        axiosInstance.get(`/iphone/json/api/auto_ticker/${componentaId}`)
            .then((res: any) => { this.setState({ tickerArticles: res.data.data.tickerAuto.data }); })
            .then(() => {
                const zeroMinDiff = this.state.tickerArticles.some((article) => minutesDiff(article) === 0);
                const upToFiveMinDiff = this.state.tickerArticles.some((article) => minutesDiff(article) < highlightDur);

                if (isFirstInterval && upToFiveMinDiff) {
                    this.setState({ shouldDisplayLoader: true })
                    setTimeout(() => {
                        this.setState({ shouldDisplayLoader: false })
                    }, 3000)
                };

                if (!isFirstInterval && zeroMinDiff) {
                    this.setState({ shouldDisplayLoader: true })
                    setTimeout(() => {
                        this.setState({ shouldDisplayLoader: false })
                    }, 3000)
                };
            })
            .catch(err => console.error("error geting ticker data:", err))
    }

    public render() {
        const { tickerBottomLink, languageCode, tickerBottomTitle, highlightingDuration, roofOngoingEvent, isLTR, domain } = this.props;
        const { tickerArticles, shouldDisplayTicker, isFirstInterval } = this.state;
        const highlightDur = highlightingDuration ? highlightingDuration : 3;
        let flashTitle = "מבזקים";

        if (languageCode && languageCode.includes("en")) {
            flashTitle = "Breaking News"
        }
        else if (languageCode && languageCode.includes("ru")) {
            flashTitle = "последние новости"
        }

        return (
            <div className="news-flash-special-mobile-component">
                <div className="news-flash-special-mobile-tab">
                    <div className="tab-icon"></div>
                    <div className="tab-title">{flashTitle}</div>
                </div>

                <NewsFlashSpecialMobileSlotList
                    isLTR={isLTR}
                    domain={domain}
                    languageCode={languageCode}
                    tickerArticles={tickerArticles}
                    isFirstInterval={isFirstInterval}
                    roofOngoingEvent={roofOngoingEvent}
                    highlightingDuration={highlightDur}
                    tickerBottomLink={tickerBottomLink}
                    tickerBottomTitle={tickerBottomTitle}
                    shouldDisplayTicker={shouldDisplayTicker}
                    shouldDisplayLoader={this.state.shouldDisplayLoader}
                />
            </div >
        )
    }
}

export const minutesDiff = (article: ArticleExtraData) => {
    return Math.floor((new Date().getTime() - article.dateUpdatedOnSite.getTime()) / (1000 * 60));
}